"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _context = require("../../../../services/log/context");
var validators = _interopRequireWildcard(require("../../../../services/input/validators"));
var _events = require("../../consts/events");
var _errors = _interopRequireDefault(require("../../../../consts/errors"));
var _checkEmail = _interopRequireDefault(require("../../mutations/checkEmail"));
var _EmailLogin = _interopRequireDefault(require("../screens/EmailLogin"));
var _otpLogin = _interopRequireDefault(require("../../mutations/otpLogin"));
var _createAccount = _interopRequireDefault(require("../../mutations/createAccount"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const EmailLogin = _ref => {
  let {
    email,
    emailSuggestion,
    onEmailCorrection,
    brandId,
    magicLinkError,
    onEmailChange,
    onChangeScreen,
    onSendMagicLink,
    isSimplifiedLoginFlow,
    onOtpTransactionIdChange,
    onOtpFlowChange
  } = _ref;
  const [error, setError] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [validateEmail, setValidateEmail] = React.useState(false);
  const {
    log
  } = (0, _context.useLog)();
  const intl = (0, _reactIntl.useIntl)();
  const handleEmailBlur = () => {
    if (email === "") {
      return setError(null);
    }
    return setValidateEmail(true);
  };
  const initiateEmailConfirmation = _ref2 => {
    let {
      source
    } = _ref2;
    (0, _otpLogin.default)({
      email,
      brandId
    }).then(res => {
      if ("transactionId" in res) {
        log(_events.OTP_LOGIN_SUCCESS, {
          flow: source
        });
        onOtpFlowChange(source);
        onOtpTransactionIdChange(res.transactionId);
        onChangeScreen("verifyEmail");
        setIsLoading(false);
        return;
      }
      setIsLoading(false);
      log(_events.OTP_LOGIN_FAILED, {
        operation: "otpLogin",
        error: res.error
      });
      setError(_errors.default.general);
    }).catch(err => {
      setIsLoading(false);
      setError(_errors.default.general);
      log(_events.CRITICAL_LOGIN_ERROR, {
        error: String(err),
        operation: "otpLogin"
      });
    });
  };
  const createAccountAndInitEmailVerification = () => {
    (0, _createAccount.default)({
      brandId,
      credentials: {
        email
      },
      language: intl.locale
    }).then(res => {
      if ("success" in res) {
        log(_events.REGISTRATION_SENT, {
          email,
          isSimplifiedLoginFlow: true
        });
        initiateEmailConfirmation({
          source: "registration"
        });
        return;
      }
      setIsLoading(false);
      log(_events.LOGIN_STEP_FAILED, {
        operation: "createAccount",
        error: res.error || ""
      });
      setError(_errors.default.general);
    }).catch(err => {
      setIsLoading(false);
      log(_events.CRITICAL_LOGIN_ERROR, {
        error: String(err),
        operation: "createAccount"
      });
    });
  };
  const handleCheckEmail = e => {
    e.preventDefault();
    if (validateInput()) {
      return;
    }
    setIsLoading(true);
    setError(null);
    (0, _checkEmail.default)({
      email,
      brandId
    }).then(result => {
      if (!result) {
        setIsLoading(false);
        log(_events.LOGIN_STEP_FAILED, {
          operation: "checkEmail"
        });
        setError(_errors.default.general);
        return;
      }
      if (result.hasKiwiAccount) {
        log(_events.HAS_KIWI_ACCOUNT, {
          hasPassword: result.hasPassword,
          isVerified: result.emailVerified
        });
        if (result.emailVerified && result.hasPassword) {
          log(_events.CONTINUE_TO_PASSWORD, {});
          onChangeScreen("password");
        } else if (!result.emailVerified && isSimplifiedLoginFlow) {
          initiateEmailConfirmation({
            source: "notVerified"
          });
        } else if (!result.hasPassword && isSimplifiedLoginFlow) {
          initiateEmailConfirmation({
            source: "noPassword"
          });
        } else {
          onSendMagicLink();
        }
        return;
      }
      log(_events.NO_KIWI_ACCOUNT, {});
      if (isSimplifiedLoginFlow) {
        createAccountAndInitEmailVerification();
      } else {
        setIsLoading(false);
        onChangeScreen("signUp");
      }
    }).catch(err => {
      log(_events.CRITICAL_LOGIN_ERROR, {
        error: String(err),
        operation: "checkEmail"
      });
      setIsLoading(false);
      setError(_errors.default.general);
    });
  };
  const validateInput = () => {
    const error = email ? validators.email(email) : _errors.default.requiredField;
    setValidateEmail(true);
    return Boolean(error);
  };
  const getEmailError = () => {
    if (!validateEmail) {
      return null;
    }
    return email ? validators.email(email) : _errors.default.requiredField;
  };
  const submitError = error !== null && error !== void 0 ? error : magicLinkError;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmailLogin.default, {
    email: email,
    emailSuggestion: emailSuggestion,
    onEmailCorrection: onEmailCorrection,
    error: submitError == null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        ...submitError
      })
    }),
    isLoading: isLoading,
    onEmailChange: onEmailChange,
    onEmailBlur: handleEmailBlur,
    onContinue: handleCheckEmail,
    emailError: getEmailError()
  });
};
var _default = exports.default = EmailLogin;